import React, { ReactNode, useState } from "react";
import { createUseStyles, useTheme } from "react-jss";
import { GlobalToken } from "antd/es/theme/interface";
import HeaderLeftBlock from "./HeaderLeftBlock";
import HeaderTitle from "./HeaderTitle";
import HeaderRightBlock from "./HeaderRightBlock";
import HeaderDrawer from "./HeaderDrawer";
import HeaderRightDrawer from "./HeaderRightDrawer";
import { EmployeeUpdateDTO } from "../../types/auth/EmployeeUpdateDTO";
import { Grid } from "antd";

export type ListProps = {
  title: string;
  link: string;
  hidden?: boolean;
  hiddenInHeader: boolean;
  icon?: ReactNode;
};

const { useBreakpoint } = Grid;
interface NewHeaderProps {
  list: ListProps[];
  extra?: React.ReactNode;
  logoUrl: string;
  activeWarning: boolean;
  toggleWarning: () => void;
  printTypes: string[] | undefined;
  updateEmployee: (dto: EmployeeUpdateDTO) => void;
  section?: ListProps;
  setSection: (it: ListProps | undefined) => void;
}

const useStyles = createUseStyles<string, unknown, GlobalToken>((theme) => ({
  header: {
    display: "grid",
    gridTemplateColumns: `1fr 1fr 1fr`,
    gap: "20px",
    alignItems: "center",
    padding: "1rem 24px",
    borderBottom: `1px solid ${theme.colorBorder}`,
  },
}));

const Header: React.FC<NewHeaderProps> = ({
  list,
  extra,
  logoUrl,
  activeWarning,
  toggleWarning,
  printTypes,
  updateEmployee,
  section,
  setSection,
}) => {
  const theme = useTheme<GlobalToken>();
  const [active, setActive] = useState(false);
  const classes = useStyles({ theme });
  const screens = useBreakpoint();

  const onOpenHandler = () => setActive(true);

  const onCloseHandler = (section: ListProps | undefined) => {
    if (section) setSection(section);
    setActive(false);
  };

  return (
    <>
      <div className={classes.header}>
        <HeaderLeftBlock logo_url={logoUrl} onOpen={onOpenHandler} />
        {screens.xs ? "" : <HeaderTitle title={section?.title} />}
        <HeaderRightBlock
          list={list}
          extra={extra}
          updateEmployee={updateEmployee}
          setSection={setSection}
        />
        <HeaderDrawer
          logoUrl={logoUrl}
          active={active}
          onClose={onCloseHandler}
          list={list}
        />
        <HeaderRightDrawer
          changeSection={() =>
            setSection(list.filter((it) => it.link === "/")?.at(0))
          }
          printTypes={printTypes}
          active={activeWarning}
          onClose={toggleWarning}
        />
      </div>
    </>
  );
};

export default Header;
